var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle-2 mt-5 align-center d-flex justify-center",staticStyle:{"margin":"0 auto"}},[_c('img',{attrs:{"src":require("@/assets/images/main/svg/icon_error.svg")}}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm._f("translate")('유효하지 않은 ID 입니다.')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }